export default {
  forms: {
    title: 'Formulaires',
    loading: 'Chargement...',
    noForms: 'Aucun formulaire soumis pour le moment.',
    submittedOn: 'Soumis le',
    backToList: 'Retour aux formulaires',
    notFound: 'Formulaire introuvable.',
    errors: {
      load: 'Échec du chargement des formulaires. Veuillez réessayer.',
      loadOne: 'Échec du chargement du formulaire. Veuillez réessayer.',
    },
  },
};
